var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReportPreview = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 13,
  fill: "none",
  viewBox: "0 0 17 13",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4,
  d: "M1 6.5S3.727 1 8.5 1 16 6.5 16 6.5 13.273 12 8.5 12 1 6.5 1 6.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4,
  d: "M8.5 8.563c1.13 0 2.046-.924 2.046-2.063S9.63 4.438 8.5 4.438 6.455 5.36 6.455 6.5c0 1.14.915 2.063 2.045 2.063"
})));
export { SvgReportPreview as ReactComponent };
export default __webpack_public_path__ + "assets/images/report-preview.svg";